
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/antara/tutorials/activate-antara-smartchain",
      function () {
        return require("private-next-pages/en/docs/antara/tutorials/activate-antara-smartchain/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/antara/tutorials/activate-antara-smartchain"])
      });
    }
  